import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { PresentationContainer } from '@Components/index';
import { useGetITRequestFormQuery } from '@Features/EmployeeSelfService/requests/ITRequisition/store/api/itRequisitionApiSlice';
import { useAppDispatch } from '@Hooks/index';
import { useGetUserInfoMutation } from '@Store/api/userApiSlice';
import { userInfoActions } from '@Store/slices/userInfoSlice';
import { ITRequestApproveForm } from '@Features/EmployeeSelfService/requests/ITRequisition/form';

const ITReqApproveForm: React.FC = () => {
  const { taskId, requestId } = useParams<{
    taskId: string;
    requestId: string;
  }>();
  const dispatch = useAppDispatch();

  const { data, isSuccess } = useGetITRequestFormQuery(requestId!);
  const [getUser] = useGetUserInfoMutation();

  useEffect(() => {
    if (data?.empNumber) {
      getUser({ empNo: data.empNumber })
        .unwrap()
        .then((user) => {
          dispatch(userInfoActions.setCreatedUserRequest(user));
        });
    }
  }, [data?.empNumber]);

  if (!isSuccess || !data) {
    return null;
  }

  return (
    <PresentationContainer fullHeight>
      <ITRequestApproveForm taskId={taskId!} formData={data} />
    </PresentationContainer>
  );
};

export default ITReqApproveForm;
